var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 74",
    enableBackground: "new 0 0 300 74",
    width: 300,
    height: 74,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustrations"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "XtraMath logo in white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "logo-white"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M69.9,64.5v2.7c0,1.4-1.1,2.6-2.4,2.6H6.3c-1.3,0-2.3-1.2-2.3-2.6V6.4C3.9,5,5,3.9,6.3,3.9h61.3 c1.3,0,2.4,1.1,2.4,2.6V10h3.9V6.3c0-3.5-2.6-6.3-5.8-6.3H5.8C2.6,0,0,2.8,0,6.3v60.9c0,3.5,2.6,6.5,5.8,6.5h62.1 c3.2,0,5.8-3,5.8-6.5v-2.7H69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC741",
    d: "M19.7,13.1l17,17l17.1-17l6.3,6.2L43,36.5l17.1,17l-6.3,6.3L36.7,42.8l-17,17.1l-6.3-6.3l17.1-17 L13.4,19.4L19.7,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M68,60.2V33H62v-6.8H68V13.4h7.8v12.9h5.9V33h-5.9v27.1H68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M93,31.7c0.8-2.2,1.9-3.9,3.3-5c1.4-1.1,3.1-1.6,5.1-1.6c1.1,0,2.2,0.1,3.2,0.4c1.1,0.3,2.1,0.6,3.1,1.1 l-2.8,6.6c-0.7-0.5-1.4-0.8-2.2-1.1c-0.8-0.2-1.6-0.3-2.6-0.3c-2.6,0-4.4,1-5.6,3.1C93.6,37,93,40.4,93,45.3v14.9h-7.8v-34H93 V31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M141.2,60.2h-7.8v-4.4c-1.4,2-3,3.4-4.8,4.4c-1.8,1-4,1.4-6.3,1.4c-4.8,0-8.6-1.6-11.3-4.9 c-2.8-3.3-4.1-7.8-4.1-13.5c0-5.4,1.4-9.8,4.2-13.1c2.8-3.3,6.5-5,11-5c2.8,0,5.1,0.6,7.1,1.7c2,1.2,3.4,2.8,4.3,5v-5.6h7.8V60.2z  M133.6,43.1c0-3.5-0.8-6.2-2.4-8.2c-1.6-2-3.9-2.9-6.8-2.9c-2.9,0-5.2,1-6.9,3c-1.7,2-2.5,4.8-2.5,8.4c0,3.6,0.8,6.4,2.4,8.3 c1.6,2,3.9,2.9,6.9,2.9c2.8,0,5-1.1,6.8-3.2C132.8,49.4,133.6,46.6,133.6,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M192,34.3c-0.1-0.4-0.3-1.5-0.5-3.4c-0.2-1.5-0.4-2.8-0.5-3.8c-0.2,1.2-0.5,2.4-0.9,3.6 c-0.4,1.2-0.9,2.4-1.5,3.6l-13.7,27.9l-13.7-28.5c-0.6-1.2-1.1-2.3-1.5-3.4c-0.4-1.1-0.8-2.2-1.1-3.3c0,1.1-0.1,2.2-0.3,3.4 c-0.2,1.2-0.4,2.5-0.7,3.8l-5.6,25.8h-7.8l12.4-54.5l15.5,33c0.2,0.5,0.6,1.4,1.1,2.6c0.5,1.2,1.1,2.7,1.8,4.5 c0.5-1.5,1.3-3.4,2.4-5.7c0.3-0.6,0.5-1.1,0.6-1.4l15.1-33l12.7,54.5h-7.9L192,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M240.2,60.2h-7.8v-4.4c-1.4,2-3,3.4-4.8,4.4c-1.8,1-4,1.4-6.3,1.4c-4.8,0-8.6-1.6-11.3-4.9 c-2.8-3.3-4.1-7.8-4.1-13.5c0-5.4,1.4-9.8,4.2-13.1c2.8-3.3,6.5-5,11-5c2.8,0,5.1,0.6,7.1,1.7c2,1.2,3.4,2.8,4.3,5v-5.6h7.8V60.2z  M232.6,43.1c0-3.5-0.8-6.2-2.4-8.2c-1.6-2-3.9-2.9-6.8-2.9c-2.9,0-5.2,1-6.9,3c-1.7,2-2.5,4.8-2.5,8.4c0,3.6,0.8,6.4,2.4,8.3 c1.6,2,3.9,2.9,6.8,2.9c2.8,0,5.1-1.1,6.8-3.2C231.8,49.4,232.6,46.6,232.6,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M249.8,60.2V33h-5.9v-6.8h5.9V13.4h7.8v12.9h5.9V33h-5.9v27.1H249.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M267.3,60.2V4.7h7.3v27.1c1.5-2.3,3.4-4.1,5.5-5.1c2.1-1.1,4.6-1.6,7.6-1.6c2.5,0,4.7,0.4,6.5,1.2 c1.8,0.8,3.2,2,4.2,3.6c0.6,0.9,1,2,1.3,3.3c0.3,1.2,0.4,3.4,0.4,6.5v20.6h-7.8V42.8c0-4.5-0.5-7.4-1.6-8.9 c-1.1-1.5-3-2.2-5.8-2.2c-1.8,0-3.4,0.3-4.8,1c-1.4,0.7-2.5,1.6-3.3,2.8c-0.6,0.8-1,1.9-1.2,3.1c-0.2,1.3-0.3,3.3-0.3,6.1v15.4 H267.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.920052e943e2c097b99e03197c5cb3c1.svg";
export { ForwardRef as ReactComponent };